var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{class:`col-${_vm.item.form.size} ${_vm.item.form.class}`,style:(_vm.item.form.style),attrs:{"form":_vm.item.form.form,"variant":_vm.item.form.variant,"data":_vm.dataValue,"topbarControls":_vm.topbarControls,"selectedItem":_vm.selectedItem,"setSelectedItems":_vm.setSelectedItems,"updateSelectedItem":_vm.updateSelectedItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }